import { FEATURE_QUALITY_MAP } from '../constants.ts';

export const getFeatureQualityLabel = (
  feature: keyof typeof FEATURE_QUALITY_MAP,
  qualityRating?: number,
  shortName = false,
) => {
  if (!qualityRating) {
    return '-';
  }

  const feat = FEATURE_QUALITY_MAP[feature][qualityRating - 1];

  if (feat === undefined) {
    throw new Error('Failed to find feature quality label, invalid quality rating');
  }

  return shortName ? feat.shortName : feat.longName;
};
